/* eslint-disable no-param-reassign */
import { flow } from 'mobx-state-tree';
import request from '~/api/request';
import { IVersionModel } from './model';

export default (self: IVersionModel) => ({
  fetch: flow(function* fetch() {
    try {
      self.startFetching();
      const {
        headers: { 'last-modified': lastModified }
      } = yield request('head', '', null, { api: false, baseURL: '/' });
      self.finishFetching();
      return lastModified;
    } catch (error) {
      self.failFetching(error);
    }
    return null;
  }),
  setLastModified(lastModified: string) {
    self.last_modified = lastModified;
  }
});
